import { createAction, props } from '@ngrx/store';
import { ServiceInfo } from '../../../cost-module/models/service-info';

export const getServiceInfoSuccess = createAction(
  '[CostModule/API] Get Service Info Success',
  props<{data: ServiceInfo[]}>()
);

export const getServiceInfoFailure = createAction(
  '[CostModule/API] Get Service Info Failure',
  props<{error: any}>()
);

export type CostModuleApiActionsUnion = ReturnType<
  typeof getServiceInfoSuccess |
  typeof getServiceInfoFailure
  >;
